export const exploreAddressInputDataHooks = {
  addressInput: 'address-input',
  locationPrediction: 'location-prediction',
};
